export const INITIAL_VALUE = '0';
export const DEFAULT_PREDEFINED_VALUE = '98090117';
export const PREDEFINED_VALUE_STORAGE_NAME = 'magic-calculator-value';